<template>


  <div v-if="canTrack">


    <v-menu
        transition="slide-y-transition"
        bottom

    >

      <template v-slot:activator="{ on }">

        <v-btn v-on="on" :loading="isLoading" icon>
          <v-icon v-if="!is_break" :color="is_working ? 'info' : ''">mdi-timer</v-icon>
          <v-icon v-else color="warning">mdi-coffee</v-icon>
        </v-btn>

      </template>

      <v-card width="300">

        <v-list dense class="ma-0 pa-0">

          <v-list-item @click="endBreak()" v-if="is_break">

            <v-list-item-avatar>
              <v-icon>mdi-coffee-off</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>

              <v-list-item-title>{{ $t('worktime_tracking.label.end-break') }}</v-list-item-title>

            </v-list-item-content>

          </v-list-item>

          <v-list-item @click="goToBreak()" v-if="is_working && !is_break">

            <v-list-item-avatar>
              <v-icon>mdi-coffee</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>

              <v-list-item-title>{{ $t('worktime_tracking.label.start-break') }}</v-list-item-title>

            </v-list-item-content>

          </v-list-item>

          <v-list-item @click="goHome()" v-if="is_working || is_break">


            <v-list-item-avatar>
              <v-icon>mdi-logout</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>

              <v-list-item-title>{{ $t('worktime_tracking.label.go-home') }}</v-list-item-title>

            </v-list-item-content>

          </v-list-item>

          <v-list-item @click="startWork()" v-if="!is_working && !is_break">


            <v-list-item-avatar>
              <v-icon>mdi-rocket-launch</v-icon>
            </v-list-item-avatar>

            <v-list-item-content>

              <v-list-item-title>{{ $t('worktime_tracking.label.start-working') }}</v-list-item-title>

            </v-list-item-content>

          </v-list-item>

        </v-list>


      </v-card>


    </v-menu>


  </div>

</template>


<script>
import {sessionStore} from '@/store/pinia/sessionStore'

export default {

  setup() {

    const session = sessionStore();

    return {
      // you can return the whole store instance to use it in the template
      session,

    }

  },

  name: "TimeTrackingWidget",
  data: function () {

    return {
      isLoading: true,
      work_status: null
    }

  },


  mounted: function () {

    let self = this;

    // The status endpoint requires the base role, so asking without it only earns a 403.
    if (self.mayUseTracking) {
      self.loadStatus();
    }

  },


  computed: {

    /**
     * Base right to take part in time tracking at all. Roles are delivered
     * hierarchy-resolved, so worktime_tracking_pling and the admin roles resolve
     * down to worktime_tracking as well.
     */
    mayUseTracking: function () {

      let self = this;
      return self.session.getUserRoles.indexOf('worktime_tracking') !== -1;

    },

    hasTrackingRole: function () {

      let self = this;
      return self.session.getUserRoles.indexOf('worktime_tracking_pling') !== -1;

    },

    canTrack: function () {

      let self = this;
      return self.hasTrackingRole || (self.work_status && self.work_status.can_track === true);

    },

    is_working: function () {

      let self = this;
      return self.work_status && self.work_status.current_session && self.work_status.current_session.is_work_session;

    },

    is_break: function () {

      let self = this;


      return self.work_status && self.work_status.current_session && !self.work_status.current_session.is_work_session;


    }

  },

  methods: {

    loadStatus() {


      let self = this;

      self.isLoading = true;
      self.$http.post('/api/v3/work-tracking/status').then(function (response) {


        self.work_status = response.data.payload;
        self.isLoading = false;

      }).catch(function () {

        // User is not allowed to track time (no role, no Home-Office day) -> hide widget.
        self.work_status = null;
        self.isLoading = false;

      })

    },

    endBreak() {

      let self = this;
      self.isLoading = true;

      self.isLoading = true;


      self.$http.post('/api/v3/work-tracking/break/end').then(function(response){

        self.loadStatus();

      });

    },

    goToBreak() {

      let self = this;
      self.isLoading = true;


      self.$http.post('/api/v3/work-tracking/break/start').then(function(response){

        self.loadStatus();

      });

    },

    startWork() {

      let self = this;
      self.isLoading = true;
      self.$http.post('/api/v3/work-tracking/session/start').then(function(response){

        self.loadStatus();

      });

    },

    goHome() {

      let self = this;
      self.isLoading = true;
      self.$http.post('/api/v3/work-tracking/session/stop').then(function(response){

        self.loadStatus();

      });

    },

  }

}

</script>